import { Backdrop, Grow, Modal } from '@material-ui/core';
import React from 'react';
import { FormattedMessage } from 'react-intl';

/**
 * VEC-4067: tickets asociados a una factura de la grilla, cada uno como link a su vista detallada
 * (se abre en una pestaña nueva). Se muestra al hacer clic en el badge "Tickets N" de la columna
 * Ticket, que aparece cuando la factura tiene más de un ticket.
 *
 * @param props.open         si el modal está abierto
 * @param props.factura      fila de la grilla: { nroPrefacturacion, tipo, puntoDeVenta, numero,
 *                           gerenciador: { razonSocial }, tickets: [ids] }
 * @param props.handleClose  cierra el modal
 */
const FacturasTicketsModal = (props) => {
    const factura = props.factura || {};
    const tickets = Array.isArray(factura.tickets) ? factura.tickets : [];

    // Con prefacturación habilitada la factura se identifica por su Nro. de prefacturación; si no, por su tipo.
    // Nro. y Pto. de venta se muestran siempre que existan.
    const identificador = factura.nroPrefacturacion ? factura.nroPrefacturacion : factura.tipo;
    const proveedor = factura.gerenciador && factura.gerenciador.razonSocial ? factura.gerenciador.razonSocial : '';

    return (
        <Modal
            open={!!props.open}
            onClose={() => props.handleClose()}
            closeAfterTransition
            BackdropComponent={Backdrop}
            BackdropProps={{ timeout: 500 }}
        >
            <Grow in={!!props.open}>
                <div className="" tabIndex="-1" id="facturas_tickets_modal" role="dialog" aria-labelledby="facturasTicketsModalLabel">
                    <div className="modal-dialog" role="document">
                        <div className="modal-content">
                            <div className="modal-header bg-fleet">
                                <h4 className="modal-title text-white" id="facturasTicketsModalLabel">
                                    <i className="la la-ticket align-middle icon-modal-title"></i>
                                    <FormattedMessage id="facturasGrid.render.tickets_modal.header_tickets_asociados" defaultMessage=" Tickets asociados" />
                                </h4>
                                <button type="button" onClick={() => props.handleClose()} className="close" aria-label="Close">
                                    <span aria-hidden="true">&times;</span>
                                </button>
                            </div>
                            <div className="modal-body modal-grey">
                                <p className="mb-1">
                                    <span className="text-muted"><FormattedMessage id="facturasGrid.render.tickets_modal.label_factura" defaultMessage="Factura" /></span> <strong>{identificador}</strong>
                                    {factura.numero && (
                                        <React.Fragment>
                                            {' · '}<span className="text-muted"><FormattedMessage id="facturasGrid.render.tickets_modal.label_numero" defaultMessage="Nro." /></span> <strong>{factura.numero}</strong>
                                        </React.Fragment>
                                    )}
                                    {factura.puntoDeVenta && (
                                        <React.Fragment>
                                            {' · '}<span className="text-muted"><FormattedMessage id="facturasGrid.render.tickets_modal.label_punto_de_venta" defaultMessage="Pto. de venta" /></span> <strong>{factura.puntoDeVenta}</strong>
                                        </React.Fragment>
                                    )}
                                    {proveedor && (
                                        <React.Fragment>
                                            <br />
                                            <span className="text-muted"><FormattedMessage id="facturasGrid.render.tickets_modal.label_proveedor" defaultMessage="Proveedor" /></span> <strong>{proveedor}</strong>
                                        </React.Fragment>
                                    )}
                                </p>
                                <ul className="list-unstyled mb-0">
                                    {tickets.map((ticketId) => (
                                        <li key={ticketId} className="d-flex justify-content-between border-top py-1">
                                            <a href={'/tickets/' + ticketId} target="_blank" rel="noopener noreferrer" style={{ display: 'inline-flex', alignItems: 'center', gap: 4, fontWeight: 600 }}>
                                                {ticketId}<i className="la la-external-link" style={{ fontSize: '1.05em', lineHeight: 1, transform: 'translateY(.75px)' }}></i>
                                            </a>
                                            <small className="text-muted">
                                                <FormattedMessage id="facturasGrid.render.tickets_modal.se_abre_en_pestania_nueva" defaultMessage="Se abre en una pestaña nueva" />
                                            </small>
                                        </li>
                                    ))}
                                </ul>
                            </div>
                            <div className="modal-footer modal-grey">
                                <button type="button" className="btn btn-default btn-fleet" onClick={() => props.handleClose()}>
                                    <FormattedMessage id="facturasGrid.render.tickets_modal.cerrar" defaultMessage="Cerrar" />
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </Grow>
        </Modal>
    );
};

export default FacturasTicketsModal;
